<script>
export default {
  name: 'EmptyStateBlock',
  props: {
    icon: {
      type: String,
      default: 'mdi-information',
    },
    title: {
      type: String,
      default: 'No Data',
    },
    description: {
      type: String,
      default: 'No data was found',
    },
    button: {
      type: Object,
      default: () => null,
    },
    border: {
      type: Boolean,
    },
  },
}
</script>

<template>
  <section
    :class="[
      'd-flex flex-column justify-center align-center text-center h-100 pa-8',
      border ? 'border' : '',
    ]"
  >
    <slot name="icon">
      <v-icon color="indigo" class="mb-5" x-large> {{ icon }} </v-icon>
    </slot>
    <slot name="title">
      <h3 :class="[description || button ? 'mb-2' : '']">{{ title }}</h3>
    </slot>
    <slot name="description">
      <p>{{ description }}</p>
    </slot>

    <slot name="button">
      <v-btn
        v-if="button"
        :id="button.id"
        class="rounded-lg mt-6"
        dark
        :to="button.to"
        :color="button.color"
        outlined
        depressed
      >
        <v-icon v-if="button.icon" left>
          {{ button.icon }}
        </v-icon>
        {{ button.text }}
      </v-btn>
    </slot>
  </section>
</template>
